module.exports = __webpack_public_path__ + "static/media/google-play-badge-ru.99177668.svg";